import $ from 'jquery';
import Isotope from 'isotope-layout';
import Scrollbar from 'smooth-scrollbar';

$(document).ready(function() {
    $('.isotopeListing').each(function (index, element) {
        const listingSelector = '.listing';
        const listSelector = listingSelector + '__list';
        const itemSelector = listingSelector + '__item';
        const $listing = $(element);
        const $filters = $listing.find(listingSelector + '__filters');
        const $featureCheckboxes = $filters.find('.featureCheckbox');
        const $items = $listing.find(itemSelector);
        const $pagination = $listing.find(listingSelector + '__pagination');
        const $nothingFound = $listing.find(listingSelector + '__nothingFound');
        const step = 6;
        let visibleItemsNum = step;
        let matchCounter = 0;
        let isotope = null;
        let filters = [];

        function resetItemsHeight() {
            //$items.css('height', '');
            $items.each(function (index, element) {
                const $item = $(element);
                $item.css('height', $item.outerHeight());
            });
        }

        function showMoreItems() {
            matchCounter = 0;
            visibleItemsNum = visibleItemsNum + step;
            applyFilters(false);
        }

        function alignItemsHeight() {
            let itemsInRow = [];
            let rowHeight = 0;
            const filteredElements = isotope.getFilteredItemElements();
            resetItemsHeight();
            filteredElements.forEach(function (element, index) {
                const $item = $(element);
                if ( index > 0 ) {
                    if ( $item.offset().top === $(filteredElements[index-1]).offset().top ) {
                        itemsInRow.push( $item );
                        rowHeight = $item.outerHeight() > rowHeight ? $item.outerHeight() : rowHeight;
                    }
                    else {
                        itemsInRow.forEach(function ($item) {
                            $item.css('height', rowHeight);
                        });
                        itemsInRow = [ $item ];
                        rowHeight = $item.outerHeight();
                    }
                } else {
                    itemsInRow.push( $item );
                    rowHeight = $item.outerHeight();
                }
                if ( index === filteredElements.length - 1 ) {
                    itemsInRow.forEach(function ($item) {
                        $item.css('height', rowHeight);
                    });
                }
            });
        }

        function isotopeFilter() {
            const thisElement = this;
            const match = Object.values(filters).every(classes => {
                if (!classes || classes.length === 0) return true;
                return classes.some(className => thisElement.classList.contains(className));
            });
            if ( match ) {
                matchCounter++;
            }
            return match && matchCounter <= visibleItemsNum;
        }

        function readHash() {
            if (location.hash.length > 1 ) {
                filters = Object.fromEntries(
                    location.hash
                        .replace(/^#/, '')
                        .split('&')
                        .map(pair => {
                            const [key, value = ''] = pair.split('=');
                            return [key, value.split(',')];
                        })
                );
            }
            setFilters();
            applyFilters(false);
        }

        function updateHash() {
            const params = new URLSearchParams();
            Object.keys(filters).forEach(function (key) {
                params.set(key, filters[key]);
            });
            const hash = decodeURIComponent(params.toString());
            if (hash) {
                location.hash = '#' + hash;
            } else {
                history.replaceState(null, '', location.pathname + location.search);
            }
        }

        function applyFilters(pushHash) {
            matchCounter = 0;
            isotope.arrange();
            $pagination.toggle( matchCounter > visibleItemsNum );
            $nothingFound.toggle( matchCounter === 0 );
            if (pushHash) {
                updateHash();
            }
        }

        function getFilters() {
            filters = [];
            if ( $featureCheckboxes.is(':checked') ) {
                filters[$featureCheckboxes.attr('name')] = [];
                $featureCheckboxes.each(function (index, element) {
                    if ( $(element).is(':checked') ) {
                        filters[$featureCheckboxes.attr('name')].push($(element).val())
                    }
                });
            }
            applyFilters(true);
        }

        function setFilters() {
            $featureCheckboxes.each(function (index, element) {
                const $option = $(element);
                $option.prop('checked', filters[$featureCheckboxes.attr('name')] && filters[$featureCheckboxes.attr('name')].includes($option.val()));
            });
        }

        $featureCheckboxes.on('change', getFilters);

        isotope = new Isotope(listSelector, {
            itemSelector: itemSelector,
            layoutMode: 'fitRows',
            filter: isotopeFilter,
            initLayout: false
        });
        isotope.on('layoutComplete', alignItemsHeight);
        readHash();
        $(window).on('hashchange', readHash);
        $pagination.on('click', 'button', showMoreItems);

        
        function scrollbarHandler() {
            const container = element.querySelector('.featuresFilter__scrollContainer');
            if (!container) {
                return;
            }
            if (innerWidth < 720) {
                Scrollbar.init(element.querySelector('.featuresFilter__scrollContainer'), {
                    damping: 0.02,
                });
            } else {
                Scrollbar.destroy(container);
            }
        }
        scrollbarHandler();
        $(window).on('resize', scrollbarHandler);
    });
});